import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useLazyQuery, useMutation } from '@apollo/client';
import {
  GET_LIBRO_ID,
  GET_LIBROS,
  SEARCH_LIBROS,
  REMOVE_LIBRO,
} from '../../graphql/actions/libro';
import axios from 'axios';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import SaveAlt from '@material-ui/icons/SaveAlt';
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Card from '../../components/UI/Card/Card';
import CardBody from '../../components/UI/Card/CardBody';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import Order from '../Order/Order';
import Filter from '../Filter/Filter';
import Limit from '../Limit/Limit';
import Paginate from '../Paginate/Paginate';
import Total from '../Total/Total';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import LibroDel from './LibroDel';

import sectionDataStyle from '../../assets/jss/coscef/views/articuloSections/sectionDataStyle';

const url =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/'
    : 'https://api.coscef.nat.cu/';

const useStyles = makeStyles(sectionDataStyle);

const LibroData = (props) => {
  const classes = useStyles();
  const [numLibros, setNumLibros] = useState(9);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [search, setSearch] = useState('');
  const [eliminarLibroModal, setEliminarLibroModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_LIBRO_ID,
      data: { getLibroId: id },
    });
    setEliminarLibroModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarLibroModal(false);
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removeLibro) setEliminarLibroModal(false);
    else console.log('Error eliminando libro.');
  };

  const updateCacheDel = (cache, id) => {
    const { getLibros } = cache.readQuery({
      query: GET_LIBROS,
      variables: {
        paginate: {
          numLibros: numLibros,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoLibros = getLibros.libros.filter((libro) => libro.id !== id);

    if (getLibros && nuevoLibros) {
      cache.writeQuery({
        query: GET_LIBROS,
        variables: {
          paginate: {
            numLibros: numLibros,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getLibros: {
            libros: nuevoLibros,
          },
        },
      });
    }
  };

  const {
    loading: loadingLibros,
    error: errorLibros,
    data: dataLibros,
    fetchMore,
  } = useQuery(GET_LIBROS, {
    variables: {
      paginate: {
        numLibros: numLibros,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [executeSearch, { loading: loadingSearch, data: dataSearch }] =
    useLazyQuery(SEARCH_LIBROS, {
      errorPolicy: 'all',
    });

  const [
    eliminarLibro,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_LIBRO, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const onDownloadFileHandler = async (e, id, fichero) => {
    e.preventDefault();
    let filename;
    if (fichero) {
      const arrayString = fichero.split('/');
      //console.log(arrayString[arrayString.length - 1]);
      filename = arrayString[arrayString.length - 1];
    }
    if (id) {
      try {
        const config = {
          responseType: 'blob', // important
          headers: {
            //'Content-Type': 'application/pdf',
            //'Content-Type': 'application/msword',
            //'Content-Type':
            //  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            //'Content-Type': 'application/vnd.ms-powerpoint',
            //'Content-Disposition': 'attachment',
            //Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
        };
        const response = await axios.get(url + 'api/file/libro/' + id, config);

        if (response.data) {
          //console.log(response.data);
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers['Content-Type'],
            })
          );
          const link = document.createElement('a');
          link.href = downloadUrl;
          link.setAttribute('download', filename); //any other extension
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        }
      } catch (error) {
        console.log(error.response.data);
      }
    }
  };

  const onSearchHandler = (event) => {
    event.preventDefault();
    executeSearch({
      variables: {
        paginate: {
          numLibros: numLibros,
          cursor: '',
          query: search,
          sortBy: { field: field, order: order },
        },
      },
    });
  };

  const removeLibroHandler = (id) => {
    eliminarLibro({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  const numLibrosChangedHandler = (event) => {
    if (event.target.name === 'numComponentes')
      setNumLibros(event.target.value);
  };

  const fieldChangedHandler = (event) => {
    if (event.target.name === 'field') setField(event.target.value);
  };

  const orderChangedHandler = (event) => {
    if (event.target.name === 'order') setOrder(event.target.value);
  };

  const searchChangedHandler = (event) => {
    if (event.target.name === 'search') setSearch(event.target.value);
  };

  const onPaginationHandler = (cursor) => {
    fetchMore({
      variables: {
        paginate: {
          numLibros: numLibros,
          cursor: cursor,
          sortBy: { field: field, order: order },
        },
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        fetchMoreResult.getLibros.libros = [
          ...prev.getLibros.libros,
          ...fetchMoreResult.getLibros.libros,
        ];
        return fetchMoreResult;
      },
    });
  };

  let showNotification = null;
  let seccionTitulo = null;
  let seccionOrderFilter = null;
  let seccionCardLibro = null;
  let seccionBotonAdd = null;
  let seccionLimitPagination = null;
  let seccionTotal = null;
  let removeModal = (
    <LibroDel
      show={eliminarLibroModal}
      close={eliminarCloseModalHandler}
      removeLibro={removeLibroHandler}
    />
  );

  if (loadingLibros) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;
  if (loadingSearch) {
    seccionOrderFilter = (
      <div id='orderandfilter' className={classes.marginBottom20}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={6}>
            <Order />
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorLibros) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>
              Error al buscar los libros en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionOrderFilter = null;
    seccionCardLibro = null;
    seccionBotonAdd = null;
    seccionLimitPagination = null;
    seccionTotal = null;

    showNotification = errorLibros.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorLibros ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataLibros && dataLibros.getLibros) {
    const { getLibros } = dataLibros;
    //console.log(getLibros);
    if (getLibros.libros.length === 0) {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron libros, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = null;
      seccionCardLibro = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'libro'} />
        </div>
      ) : null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Libros</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'libro'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardLibro = (
        <GridContainer>
          {getLibros.libros.map((libro) => (
            <GridItem xs={12} sm={4} md={4} key={libro.node._id}>
              {libro.node.caratula ? (
                <Card
                  background
                  style={{
                    backgroundImage: `url(${url}${libro.node.caratula})`,
                  }}
                >
                  <CardBody background>
                    <h4
                      className={
                        classes.cardTitleWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.titulo}
                    </h4>
                    <br />
                    <p
                      className={
                        classes.cardDescriptionWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.resumen + ' ...'}
                    </p>
                    {props.isAuth ? (
                      <div className={classes.textCenter}>
                        <Button
                          color='white'
                          round
                          justIcon
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} />
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(
                              '/editar-libro/' + libro.node._id
                            );
                          }}
                        >
                          <Icon>mode_edit</Icon>
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={() =>
                            eliminarShowModalHandler(libro.node._id)
                          }
                        >
                          <Delete />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className={
                          classes.stats + ' ' + classes.justifyContentCenter
                        }
                      >
                        <Button
                          color='white'
                          round
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} /> Obtener Libro
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Card>
              ) : (
                <Card color='dark' key={libro.node._id}>
                  <CardBody color>
                    <h4
                      className={
                        classes.cardTitleWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.titulo}
                    </h4>
                    <br />
                    <p
                      className={
                        classes.cardDescriptionWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.resumen + ' ...'}
                    </p>
                    {props.isAuth ? (
                      <div className={classes.textCenter}>
                        <Button
                          color='white'
                          round
                          justIcon
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} />
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(
                              '/editar-libro/' + libro.node._id
                            );
                          }}
                        >
                          <Icon>mode_edit</Icon>
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={() =>
                            eliminarShowModalHandler(libro.node._id)
                          }
                        >
                          <Delete />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className={
                          classes.stats + ' ' + classes.justifyContentCenter
                        }
                      >
                        <Button
                          color='white'
                          round
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} /> Datos del Libro
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Card>
              )}
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'libro'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numLibros}
                numdComponentesChange={numLibrosChangedHandler}
                nombreComponente={'Libros'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={getLibros.pageInfo.startCursor}
                cursorFinal={getLibros.pageInfo.endCursor}
                tienePaginaSiguiente={getLibros.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={getLibros.totalCount}
            nombreComponente={'Libros'}
          />
        </div>
      );
    }
  }

  if (dataSearch && dataSearch.searchLibros) {
    const { searchLibros } = dataSearch;

    if (searchLibros.libros.length === 0) {
      seccionTitulo = null;

      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}></GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'ponencia'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardLibro = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>
                No se encontraron libros en la busqueda.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionBotonAdd = null;

      seccionLimitPagination = null;
      seccionTotal = null;
    } else {
      seccionOrderFilter = (
        <div id='orderandfilter' className={classes.marginBottom20}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Order
                orderBy={order}
                orderByChange={orderChangedHandler}
                fieldBy={field}
                fieldByChange={fieldChangedHandler}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Filter
                nombreComponente={'libro'}
                searchChange={searchChangedHandler}
                runSearch={onSearchHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionCardLibro = (
        <GridContainer>
          {searchLibros.libros.map((libro) => (
            <GridItem xs={12} sm={4} md={4} key={libro.node._id}>
              {libro.node.caratula ? (
                <Card
                  background
                  style={{
                    backgroundImage: `url(${url}${libro.node.caratula})`,
                  }}
                >
                  <CardBody background>
                    <h4
                      className={
                        classes.cardTitleWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.titulo}
                    </h4>
                    <br />
                    <p
                      className={
                        classes.cardDescriptionWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.resumen + ' ...'}
                    </p>
                    {props.isAuth ? (
                      <div className={classes.textCenter}>
                        <Button
                          color='white'
                          round
                          justIcon
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} />
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(
                              '/editar-libro/' + libro.node._id
                            );
                          }}
                        >
                          <Icon>mode_edit</Icon>
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={() =>
                            eliminarShowModalHandler(libro.node._id)
                          }
                        >
                          <Delete />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className={
                          classes.stats + ' ' + classes.justifyContentCenter
                        }
                      >
                        <Button
                          color='white'
                          round
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} /> Obtener Libro
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Card>
              ) : (
                <Card color='dark' key={libro.node._id}>
                  <CardBody color>
                    <h4
                      className={
                        classes.cardTitleWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.titulo}
                    </h4>
                    <br />
                    <p
                      className={
                        classes.cardDescriptionWhite + ' ' + classes.textCenter
                      }
                    >
                      {libro.node.resumen + ' ...'}
                    </p>
                    {props.isAuth ? (
                      <div className={classes.textCenter}>
                        <Button
                          color='white'
                          round
                          justIcon
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} />
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={(e) => {
                            e.preventDefault();
                            props.history.push(
                              '/editar-libro/' + libro.node._id
                            );
                          }}
                        >
                          <Icon>mode_edit</Icon>
                        </Button>
                        <Button
                          round
                          justIcon
                          color='white'
                          onClick={() =>
                            eliminarShowModalHandler(libro.node._id)
                          }
                        >
                          <Delete />
                        </Button>
                      </div>
                    ) : (
                      <div
                        className={
                          classes.stats + ' ' + classes.justifyContentCenter
                        }
                      >
                        <Button
                          color='white'
                          round
                          onClick={(e) =>
                            onDownloadFileHandler(
                              e,
                              libro.node._id,
                              libro.node.datos
                            )
                          }
                        >
                          <SaveAlt className={classes.icons} /> Datos del Libro
                        </Button>
                      </div>
                    )}
                  </CardBody>
                </Card>
              )}
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'libro'} />
        </div>
      ) : null;

      seccionLimitPagination = (
        <div id='limitandpagination'>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Limit
                numdComponentes={numLibros}
                numdComponentesChange={numLibrosChangedHandler}
                nombreComponente={'Libros'}
              />
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Paginate
                cursorInicial={searchLibros.pageInfo.startCursor}
                cursorFinal={searchLibros.pageInfo.endCursor}
                tienePaginaSiguiente={searchLibros.pageInfo.hasNextPage}
                paginaSiguiente={onPaginationHandler}
              />
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTotal = (
        <div id='total' className={classes.marginTop60}>
          <Total
            countArticulos={searchLibros.totalCount}
            nombreComponente={'Libros'}
          />
        </div>
      );
    }
  }

  if (dataRemove && dataRemove.removeLibro) {
    const { removeLibro } = dataRemove;
    if (removeLibro.success && removeLibro.code === '200') {
      showNotification = (
        <Notification
          key={removeLibro.code}
          mostrar={removeLibro.success ? true : false}
          msg={removeLibro.message}
          stt={removeLibro.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionOrderFilter}
              {seccionCardLibro}
              {seccionBotonAdd}
              {seccionLimitPagination}
              {seccionTotal}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(LibroData);
